import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { periodParams } from "@/lib/reportsApi";
import { REPORTS } from "@/constants/testIds";
import ExportButtons from "@/components/reports/ExportButtons";
import NoShowCard from "@/components/reports/NoShowCard";

function RateTable({ title, rows, testId }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid={testId}>
      <h3 className="text-sm font-medium text-foreground mb-3">{title}</h3>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground py-6 text-center">Sin datos en este periodo.</p>
      ) : (
        <div className="space-y-2">
          {rows.map((r) => (
            <div key={r.label} className="flex items-center justify-between text-sm py-1.5 border-b border-border/60 last:border-0">
              <span className="text-foreground">{r.label}</span>
              <span className="font-medium text-foreground">{r.rate_pct}% <span className="text-muted-foreground">({r.no_show} de {r.completed + r.no_show})</span></span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/** Reporte de No-shows: tasa general + desglose por profesional y servicio. */
export default function NoShowsTab({ period }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (period.period === "custom" && (!period.start || !period.end)) return;
    setLoading(true);
    api.get("/reports/no-shows", { params: periodParams(period) })
      .then(({ data }) => setData(data))
      .catch((err) => toast({ title: "No se pudo cargar No-shows", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" }))
      .finally(() => setLoading(false));
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading || !data) return <p className="text-center text-muted-foreground py-12">Cargando no-shows...</p>;

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <ExportButtons reportKey="no_shows" period={period} />
      </div>
      <NoShowCard noShow={data} testId={REPORTS.noShowRateCard} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RateTable title="Por profesional" rows={data.by_professional} testId={REPORTS.noShowByProfessionalTable} />
        <RateTable title="Por servicio" rows={data.by_service} testId={REPORTS.noShowByServiceTable} />
      </div>
    </div>
  );
}
